<ra-modal
    [title]="(isEdit() ? 'document.edit.quote.taxeModal.titleEdit' : 'document.edit.quote.taxeModal.titleNew') | translate"
    [size]="'medium'"
    [disabled]="loading()"
    (close)="close.emit()">

    <div class="taxe-body" [formGroup]="form">

        <!-- Modo da taxa (desabilitado no modo editar) -->
        <div class="taxe-field">
            <span class="taxe-label">{{ 'document.edit.quote.taxeModal.mode' | translate }}</span>
            <ra-select [model]="modeSelectModel" (selectedOption)="onModeSelect($event)" />
        </div>

        <!-- Nome -->
        <ra-input
            formControlName="name"
            [label]="'document.edit.quote.taxeModal.name' | translate"
            [placeholder]="('document.edit.quote.taxeModal.namePlaceholder' | translate)"
        />

        <!-- Valor -->
        <div class="taxe-field">
            <ra-input
                formControlName="price"
                [type]="priceInputType"
                [currencyCode]="currencyCode()"
                [locale]="locale()"
                [label]="priceLabelKey | translate"
            />
            @if (showPercentMaxError) {
                <span class="taxe-error">{{ 'document.edit.quote.validation.percentMax' | translate }}</span>
            }
        </div>

        <!-- Salvar no catálogo (somente no modo criar) -->
        @if (!isEdit()) {
            <div class="taxe-switch-row">
                <span class="taxe-label">{{ 'document.edit.quote.taxeModal.saveInCatalog' | translate }}</span>
                <ra-switch [formControl]="form.controls.saveInCatalog" />
            </div>
        }
    </div>

    <!-- Footer fixo -->
    <div class="taxe-actions">
        <ra-button
            [label]="'common.cancel' | translate"
            [type]="'primary-outline'"
            [disabled]="loading()"
            (click)="close.emit()"
        />
        <ra-button
            [label]="'common.save' | translate"
            [type]="'primary'"
            [loading]="loading()"
            [disabled]="loading() || form.invalid"
            (click)="onSave()"
        />
    </div>
</ra-modal>
